import { memo } from 'react';
import PropTypes from 'prop-types';
import { Car } from '@phosphor-icons/react';
import { getDisplayImage } from '../../utils/carImage';
import './CarSuggestionThumbnail.css';

/**
 * 16×12 thumbnail для search-suggestions dropdown'ов.
 * Использует `getDisplayImage(car)` (для new-model — `landscapeImage`,
 * для used-VIN — `images[0]`). Если URL отсутствует — рендерит
 * силуэт машины: подпись «No img» была служебным английским текстом в любом
 * языке, а миниатюра декоративная (`alt=""`) — иконке перевод не нужен.
 *
 * Используется в `SearchBar.jsx` и `registry/Search.jsx` (issue #884,
 * discussion #22478 на MR !787).
 */
const CarSuggestionThumbnail = ({ car }) => {
  const thumb = getDisplayImage(car);

  return (
    <div className="car-thumb">
      {thumb ? (
        <img src={thumb} alt="" className="car-thumb__image" />
      ) : (
        <div className="car-thumb__fallback" data-testid="car-thumb-fallback">
          <Car size={20} aria-hidden="true" />
        </div>
      )}
    </div>
  );
};

CarSuggestionThumbnail.propTypes = {
  car: PropTypes.shape({
    isNewModel: PropTypes.bool,
    landscapeImage: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

// memo — search-suggestion list рендерит до 6 thumbnail'ов, и на каждый
// keypress в search-input родитель ре-рендерится. Shallow-prop equality
// по `car` достаточно — объекты car стабильны после fetch results.hits.
// Consistency с CarCard (тоже React.memo).
export default memo(CarSuggestionThumbnail);
